/**
 * @file MobileNav.tsx
 *
 * Mobile/tablet section switcher for the Online Shop admin. The Gravity
 * compact sidebar is desktop-only, so smaller viewports get a horizontally
 * scrollable tab bar covering the same shop sections.
 */

import { FormattedMessage, useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { adminMessages } from '../i18n/messages';
import { SHOP_NAV_ITEMS } from '../nav-items';
import styles from './AdminLayout.module.css';

/**
 * The horizontally scrollable shop section switcher for small viewports.
 *
 * @returns The mobile shop navigation.
 */
export function MobileNav() {
  const intl = useIntl();
  return (
    <div className={styles.mobileNav}>
      <span className={styles.mobileLabel}>
        <FormattedMessage {...adminMessages.shopTitle} />
      </span>
      <nav
        className={styles.mobileTabs}
        data-testid="mobile-nav"
        aria-label={intl.formatMessage(adminMessages.navMenuLabel)}
      >
        {SHOP_NAV_ITEMS.map((item) => (
          <NavLink
            key={item.id}
            to={item.path}
            data-testid={`mobile-nav-${item.id}`}
            className={({ isActive }) =>
              `${styles.mobileTab} ${isActive ? styles.mobileTabActive : ''}`
            }
          >
            <FormattedMessage {...item.label} />
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
